import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './checkbox.scss';

class Checkbox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isFocused: false
        };
    }

    onFocus = () => {
        this.setState({ isFocused: true });
    };

    onBlur = () => {
        this.setState({ isFocused: false });
    };

    getCheckboxLabelClass() {
        let checkboxClass = 'sten-checkbox';
        if (this.props.isChecked) {
            checkboxClass += ' sten-checkbox--checked';
        }
        if (this.props.className) {
            checkboxClass += ` ${this.props.className}`;
        }
        if (this.props.isDisabled) {
            checkboxClass += ' sten-checkbox--disabled';
        }
        if (!this.props.children) {
            checkboxClass += ' sten-checkbox--no-label';
        }
        if (this.state.isFocused) {
            checkboxClass += ' sten-checkbox--focused';
        }
        return checkboxClass;
    }

    render() {
        return (
            <label
                className={this.getCheckboxLabelClass()}
                htmlFor={this.props.id}
                title={this.props.title}
                onClick={this.props.onClick}
            >
                <input
                    ref={(c) => { this.input = c; }}
                    type="checkbox"
                    id={this.props.id}
                    onChange={this.props.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    name={this.props.name || this.props.id}
                    defaultChecked={this.props.isChecked}
                    disabled={this.props.isDisabled}
                    value={this.props.value}
                />
                {this.props.children}
            </label>
        );
    }
}

Checkbox.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    title: PropTypes.string,
    value: PropTypes.bool
};

Checkbox.defaultProps = {
    children: null,
    className: '',
    id: null,
    isChecked: false,
    isDisabled: false,
    name: '',
    onChange: undefined,
    onClick: undefined,
    title: '',
    value: false
};

export default Checkbox;
